/* pause.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.87 19.87" xml:space="preserve">
          <path class="foreground-gl" d="M19.11,2.88H17.63v.76A2.32,2.32,0,0,1,13,3.55V2.88H7.29v.67s0,.06,0,.09a2.32,2.32,0,0,1-4.63-.09V2.88H1.36a1,1,0,0,0-1,1V6.55H20.14V3.91A1,1,0,0,0,19.11,2.88Z" transform="translate(-0.33 -0.26)"/>
          <path class="foreground-gl" d="M4.93,5A1.43,1.43,0,0,1,3.5,3.52V1.69a1.43,1.43,0,1,1,2.86,0V3.52A1.43,1.43,0,0,1,4.93,5Z" transform="translate(-0.33 -0.26)"/>
          <path class="foreground-gl" d="M15.35,5a1.43,1.43,0,0,1-1.43-1.43V1.69a1.43,1.43,0,1,1,2.85,0V3.52A1.42,1.42,0,0,1,15.35,5Z" transform="translate(-0.33 -0.26)"/>
          <path class="foreground-gl" d="M1.36,20.14a1,1,0,0,1-1-1v-11H20.18v11a1.08,1.08,0,0,1-1.07,1H1.36ZM11.5,9.73v8.46L17.67,14ZM3.31,18.34H5.46V9.74H3.31Zm3.28,0H8.74V9.74H6.59Z" transform="translate(-0.33 -0.26)"/>
        </svg>
    `
};
